import type { FunctionComponent } from "react"

import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/dist/module/components/Layout/Layout"
import { ReadMore } from "@jobteaser/ui-kit/dist/module/components/ReadMore/ReadMore"
import { RichText } from "@jobteaser/ui-kit/dist/module/components/RichText/RichText"

import { TeamsKeyInformation } from "@/features/companyDetail/components/Teams/TeamsKeyInformation/TeamsKeyInformation"
import { useCompanyFetch } from "@/modules/companies/hooks/useCompanyFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useTracking } from "@/modules/tracking/useTracking"

import styles from "./TeamsPresentation.module.css"

export const TeamsPresentation: FunctionComponent = () => {
  const { t } = useTranslation(["companies_client"])
  const tracking = useTracking()
  const { dataCompany } = useCompanyFetch()

  if (!dataCompany) return null

  const {
    id,
    page: {
      name,
      averageAge,
      countriesPresence,
      employeeParity: { men, women, others },
      headcount,
      teamDescription,
    },
  } = dataCompany

  const showParityValue = men > 0 || women > 0 || others > 0
  const displayTeamsKeyInformation = headcount > 0 || countriesPresence.length > 0 || averageAge > 0 || showParityValue
  const displayTeamsPresentation = !!teamDescription
  const displayOnlyDescription = displayTeamsPresentation && !displayTeamsKeyInformation

  return (
    <Layout colorBlock={LAYOUT_COLOR_BLOCK.WHITE} hasBottomPadding>
      {displayTeamsPresentation && (
        <Layout.Column>
          <ReadMore
            lineLimit={7}
            readMoreText={t("companies_client.teams.presentation.readMore")}
            onClick={() =>
              tracking?.track("see_more_information_click", {
                company_id: id,
                company_name: name,
                context: "teams_presentation",
                service: "company",
              })
            }
          >
            <RichText
              resetSpacing
              allowTargetAttribute
              className={displayOnlyDescription ? styles.teamDesciption : ""}
              data-testid="company_teams_presentation"
            >
              {teamDescription}
            </RichText>
          </ReadMore>
        </Layout.Column>
      )}
      {displayTeamsKeyInformation && (
        <Layout.Column>
          <TeamsKeyInformation />
        </Layout.Column>
      )}
    </Layout>
  )
}
